import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUnits,
  fetchUnitById,
  updateUnit,
  updateStatusInUnit,
  fetchUnitDropdownForForms,
} from "./thunk";

interface UnitState {
  unitList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedUnits: any;
  unitDropdown: any[]; // Dropdown data for forms
}

const initialState: UnitState = {
  unitList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedUnits: null,
  unitDropdown: [],
};

const unitSlice = createSlice({
  name: "unit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnits.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUnits.fulfilled, (state, action) => {
        state.loading = false;
        state.unitList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchUnits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })

      .addCase(fetchUnitById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.selectedUnits = null;
      })
      .addCase(fetchUnitById.fulfilled, (state, action) => {
        state.loading = false;
        console.log("action in unit: ", action);
        state.selectedUnits = action.payload;
      })
      .addCase(fetchUnitById.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || action.error.message || "Failed to fetch Unit";
      })

      // Update unit
      .addCase(updateUnit.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.unitList = state.unitList.map((unit) =>
          unit.id === action.payload.id ? action.payload : unit
        );
        state.loading = false;
        state.error = null;
      })
      .addCase(updateUnit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Unit";
      })

      // Update Status
      .addCase(updateStatusInUnit.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateStatusInUnit.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.unitList = state.unitList.map((unit) =>
          unit.id === action.payload.id ? action.payload : unit
        );
        state.loading = false;
        state.error = null;
      })
      .addCase(updateStatusInUnit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })
      .addCase(fetchUnitDropdownForForms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUnitDropdownForForms.fulfilled, (state, action) => {
        state.loading = false;
        state.unitDropdown = action.payload;
      })
      .addCase(fetchUnitDropdownForForms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to fetch Unit dropdown";
        state.unitDropdown = [];
      });
  },
});

export default unitSlice.reducer;
